import { useEditor, EditorContent } from '@tiptap/react'
import { richTextDisplayExtensions } from '@/components/ui/minimal-tiptap/display-extensions'
import '@/components/ui/minimal-tiptap/styles/index.css'

const SupportArticleContent = ({ content }: { content: string }) => {
  const editor = useEditor({
    extensions: richTextDisplayExtensions,
    content,
    editable: false,
    immediatelyRender: false,
  })

  if (!editor) return null

  return (
    <EditorContent
      editor={editor}
      className='minimal-tiptap-editor cursor-unset'
    />
  )
}

export default SupportArticleContent
